// Modified based on
// https://github.com/akveo/kittenTricks/blob/master/src/layouts/social/profile-settings-1/extra/profile-avatar.component.tsx
import { useActionSheet } from "@expo/react-native-action-sheet";
import { Entypo, MaterialCommunityIcons } from "@expo/vector-icons";
import { Avatar, AvatarProps, Button, Text } from "@ui-kitten/components";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import {
  actionSheetHandler,
  cancelButtonIndex,
  options,
  pickImageWithouActionSheet,
} from "utils/imagePicker";

interface ProfileAvatarProps extends Omit<AvatarProps, "size"> {
  // override size property defined in AvatarProps
  editButton?: boolean;
  hasImageIdentifier: boolean;
  size?: number;
  onChange?: (uri: string) => void;
  initial?: string;
}
const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  editButton,
  style,
  hasImageIdentifier,
  size = 96,
  onChange,
  initial,
  ...props
}) => {
  const { showActionSheetWithOptions } = useActionSheet();
  const theme = useAppSelector((state) => state.theme.theme);
  const renderPhotoButton = (): React.ReactElement => (
    <Button
      testID="upload-image-button"
      style={[styles.editButton, { height: 14 }]}
      status="basic"
      size="small"
      accessoryLeft={
        <Entypo
          name="camera"
          size={16}
          color="rgb(25, 118, 210)"
          style={{ alignSelf: "center" }}
        ></Entypo>
      }
      onPress={handleEditBtnPress}
    />
  );

  const handleEditBtnPress = async () => {
    if (Platform.OS === "web") {
      pickImageWithouActionSheet((uri) => {
        onChange && onChange(uri);
      });
    } else {
      showActionSheetWithOptions(
        {
          options,
          cancelButtonIndex,
        },
        (buttonIndex) => {
          actionSheetHandler((uri) => onChange && onChange(uri), buttonIndex);
        }
      );
    }
  };

  return (
    <View>
      <View style={{ width: size, height: size }}>
        {hasImageIdentifier ? (
          <Avatar
            {...props}
            shape="square"
            style={[
              {
                width: size,
                height: size,
                borderRadius: 10,
              },
            ]}
            testID="user-profile-pic"
          />
        ) : (
          <View
            style={{
              width: size,
              height: size,
              backgroundColor: "rgb(239, 242, 252)",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 10,
            }}
          >
            {initial ? (
              <Text style={{ fontSize: size / 2 }}>{initial}</Text>
            ) : (
              <MaterialCommunityIcons
                name="account"
                size={size / 2}
                color={theme === "dark" ? "white" : "rgb(98, 126, 252)"}
              />
            )}
          </View>
        )}
        {editButton && renderPhotoButton()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  avatar: {
    alignSelf: "center",
  },
  editButton: {
    position: "absolute",
    alignSelf: "flex-end",
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    aspectRatio: 1.0,
    borderRadius: 24,
    backgroundColor: "white",
    borderColor: "rgb(25, 118, 210)",
  },
});

export default ProfileAvatar;
